import { render, staticRenderFns } from "./LegalAndZoning.vue?vue&type=template&id=17309fca"
import script from "./LegalAndZoning.vue?vue&type=script&lang=js"
export * from "./LegalAndZoning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports